"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "smartphone"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.83325 2.49998C5.37301 2.49998 4.99992 2.87308 4.99992 3.33331V16.6666C4.99992 17.1269 5.37301 17.5 5.83325 17.5H14.1666C14.6268 17.5 14.9999 17.1269 14.9999 16.6666V3.33331C14.9999 2.87308 14.6268 2.49998 14.1666 2.49998H5.83325ZM3.33325 3.33331C3.33325 1.9526 4.45254 0.833313 5.83325 0.833313H14.1666C15.5473 0.833313 16.6666 1.9526 16.6666 3.33331V16.6666C16.6666 18.0474 15.5473 19.1666 14.1666 19.1666H5.83325C4.45254 19.1666 3.33325 18.0474 3.33325 16.6666V3.33331Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.16675 15C9.16675 14.5398 9.53984 14.1667 10.0001 14.1667H10.0084C10.4687 14.1667 10.8417 14.5398 10.8417 15C10.8417 15.4603 10.4687 15.8334 10.0084 15.8334H10.0001C9.53984 15.8334 9.16675 15.4603 9.16675 15Z",
    fill: fill
  })));
};

exports["default"] = _default;